import bilAPI from "../api";

export const getSubjects = () => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/questions/subjects/`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("axios error");
        });
    } catch (error) {
      reject("system error");
    }
  });
};
